<template>
    <cell class="jc-field" @click="handleClick" :clickable="clickable" :wrapper-class="wrapperClass" :arrow="arrow" :class="[{'has-label': label}]" :icon="icon">
        <div class="jc-field-body">
            <div class="jc-field-label" :style="labelStyle" v-if="label">{{label}}</div>
            <div class="cell-input-wrapper"
            :class="[{'has-label': label}]">
                <div v-if="$slots.default" class="default-wrapper"><slot/></div>
                <input v-if="!$slots.default && !readOnly" @focus.stop="handleFocus"
                @blur.stop="handleBlur"
                :type="type"
                :readonly="readOnly"
                class="cell-input"
                :maxlength="maxlength"
                :class="{'no-padding-left': !icon && !label}"
                v-model="currentValue" :placeholder="placeholder">
                <input v-if="!$slots.default && readOnly" @focus.stop="handleFocus"
                @blur.stop="handleBlur"
                :type="type"
                unselectable="on"
                :readonly="readOnly"
                class="cell-input"
                :class="{'no-padding-left': !icon && !label}"
                onfocus="this.blur()"
                :maxlength="maxlength"
                v-model="currentValue" :placeholder="placeholder">
                <i  @click.stop="currentValue = ''" class="clear-btn van-icon van-icon-clear" :class="{show: showClear}"></i>
            </div>
        </div>
        <template slot="append"><slot name="append"/></template>
    </cell>
</template>

<script>
import Cell from './cell.vue'
export default {
  name: 'jc-field',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: String,
    readOnly: Boolean,
    value: {},
    placeholder: {},
    clearable: {
      type: Boolean,
      default: true
    },
    icon: String,
    labelWidth: {
      type: String,
      default: '20'
    }, // 填写百分比。。。
    maxlength: [Number, String],
    arrow: Boolean,
    wrapperClass: String,
    clickable: Boolean
  },
  components: {
    Cell
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value !== this.currentValue) this.currentValue = this.value
      }
    },
    currentValue () {
      this.$emit('input', this.currentValue)
    }
  },
  computed: {
    showClear () {
      return this.clearable && this.focus && this.currentValue && !this.readOnly
    },
    labelStyle () {
      if (this.labelWidth) {
        return {
          'flex-basis': `${this.labelWidth}%`
        }
      }
      return {}
    }
  },
  methods: {
    handleFocus (e) {
      this.focus = true
      this.$emit('focus', e)
    },
    handleBlur (e) {
      setTimeout(() => { this.focus = false }, 30)
      this.$emit('blur', e)
    },
    handleClick (e) {
      this.$emit('click', e)
    }
  },
  data () {
    return {
      currentValue: '',
      focus: false
    }
  }
}
</script>

<style lang="scss">
.jc-field {
    .jc-field-body {
        width: 100%;
        display: flex;
        align-items: center;
        .default-wrapper {
            padding-left: 35px;
        }
    }
}
.jc-field-label {
    padding: 0 6px;
    flex: 1;
    font-size: 24px;
    color: #606060;
}
.cell-input-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
    input {
        flex: 1;
        &.no-padding-left {
            padding-left: 0!important;
        }
    }
    &.has-label {
        // margin-left: 57px;
    }
    .clear-btn {
        display: inline-block;
        flex: 0 0 24px;
        visibility: hidden;
        &.show {
            visibility: visible;
            position: relative;
            z-index: 9999;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/cell/field.vue